
String.prototype.kzToLatin = function() {
    return this+"";
    /*let transliterate = {
        "А": "A",
        "Ә": "Á",
        "Б": "B",
        "В": "V",
        "Г": "G",
        "Ғ": "Ǵ",
        "Д": "D",
        "Е": "E",
        "Ё": "E",
        "Ж": "J",
        "З": "Z",
        "И": "I",
        "Й": "I",
        "К": "K",
        "Қ": "Q",
        "Л": "L",
        "М": "M",
        "Н": "N",
        "Ң": "Ń",
        "О": "O",
        "Ө": "Ó",
        "П": "P",
        "Р": "R",
        "С": "S",
        "Т": "T",
        "У": "Ý",
        "Ұ": "U",
        "Ү": "Ú",
        "Ф": "F",
        "Х": "H",
        "Һ": "H",
        "Ц": "Ts",
        "Ч": "Ć",
        "Ш": "Sh",
        "Щ": "Ch",
        "Ы": "Y",
        "І": "İ",
        "Э": "E",
        "Ю": "Iý",
        "Я": "Iá",
        "а": "a",
        "ә": "á",
        "б": "b",
        "в": "v",
        "г": "g",
        "ғ": "ǵ",
        "д": "d",
        "е": "e",
        "ё": "e",
        "ж": "j",
        "з": "z",
        "и": "ı",
        "й": "i",
        "к": "k",
        "қ": "q",
        "л": "l",
        "м": "m",
        "н": "n",
        "ң": "ń",
        "о": "o",
        "ө": "ó",
        "п": "p",
        "р": "r",
        "с": "s",
        "т": "t",
        "у": "ý",
        "ұ": "u",
        "ү": "ú",
        "ф": "f",
        "х": "h",
        "һ": "h",
        "ц": "ts",
        "ч": "ć",
        "ш": "sh",
        "щ": "ch",
        "ы": "y",
        "і": "i̇",
        "э": "e",
        "ю": "iý",
        "я": "iá"
    }
    return this.split('').map((c) => {
        return transliterate[c] ? transliterate[c] : c;
    }).join('');*/

    //    return this+'';

}